import { API_RESPONSE, API_REQUEST } from 'eva-fe-sdk-types';
import CrudConsumer from './index';
import Endpoint from '../lib/Endpoint';
import { SDKRequestInit } from '../lib/ApiFetch';

class Bonuses extends CrudConsumer {
  get = (config: SDKRequestInit) => {
    const url: string = Endpoint.getBonuses(this.productType);
    return this.apiFetch.get<API_RESPONSE.BonusSystem['200']>(url, config);
  };

  getCampaign = (campaignId: string, config: SDKRequestInit) => {
    const url: string = Endpoint.getBonusCampaign(this.productType, campaignId);
    return this.apiFetch.get<API_RESPONSE.BonusCampaign['200']>(url, config);
  };

  join = (campaignId: string, config: RequestInit) => {
    const url: string = Endpoint.getJoinCampaign(this.productType, campaignId);
    return this.apiFetch.post<API_RESPONSE.BonusJoin['200']>(url, config);
  };

  unjoin = (bonusId: string, config: RequestInit) => {
    const url: string = Endpoint.getUnjoinBonus(this.productType, bonusId);
    return this.apiFetch.post<API_RESPONSE.BonusUnjoin['200']>(url, config);
  };

  reject = (data: API_REQUEST.BonusSystemUnjoin, config: RequestInit) => {
    const { bonusId = '', campaignId = '' } = data;
    const url: string = Endpoint.getRejectBonus(
      this.productType,
      bonusId,
      campaignId
    );
    return this.apiFetch.post<API_RESPONSE.BonusCancel['200']>(url, config);
  };

  take = (data: API_REQUEST.BonusSystemTake, config: RequestInit) => {
    const { bonusId = '', campaignId = '' } = data;
    const url: string = Endpoint.getTakeBonus(
      this.productType,
      bonusId,
      campaignId
    );
    return this.apiFetch.post<API_RESPONSE.BonusTake['200']>(url, config);
  };
}

export default Bonuses;
